import { Dialog } from '@hai/ui-react';
import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  title?: string | ReactNode;
  bodyText?: string | ReactNode;
  cancelLabel?: string;
  primaryLabel?: string;
  primaryVariant?: string;
  onCancel?: VoidFunction;
  onPrimary?: VoidFunction;
}

export const TwoButtonsModal: React.FunctionComponent<Props> = ({
  title,
  bodyText,
  cancelLabel,
  primaryLabel,
  primaryVariant,
  onPrimary,
  onCancel,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      headline={title ?? t('reboot.presetLoadNotSavedModal.title')}
      bodyText={
        bodyText ?? (
          <>
            {t('reboot.notSavedModal.body1')}
            <br />
            {t('reboot.notSavedModal.body2')}
          </>
        )
      }
      onClose={onCancel}
      show={true}
      className="mk-modal-medium-large"
      buttons={[
        { label: cancelLabel ?? t('general.cancel'), onClick: onCancel },
        { label: primaryLabel ?? t('general.load'), variant: primaryVariant ?? 'primary', onClick: onPrimary },
      ]}
    />
  );
};
